import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";
import PaymentGatewayModel from "../../models/masters/paymentgateway-model";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/PaymentGateway/GetAllPaymentGateway";// //{/api/Block/GetAllBlock}`)  //// "https://localhost:7054/api/Block/GetAllBlock";
export const useGetPaymentGateway = createQuery<
PaymentGatewayModel[],
  null,
  AxiosError
>({
  queryKey: ["keyPaymentGatewaylist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
